"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParcelTrackingEventTypes = exports.ParcelTrackingStatus = void 0;
var ParcelTrackingStatus;
(function (ParcelTrackingStatus) {
    ParcelTrackingStatus["Created"] = "Created";
    ParcelTrackingStatus["Cancelled"] = "Cancelled";
    ParcelTrackingStatus["Repurchased"] = "Repurchased";
    ParcelTrackingStatus["PickedUpFromOrigin"] = "PickedUpFromOrigin";
    ParcelTrackingStatus["ArrivedAtOriginPort"] = "ArrivedAtOriginPort";
    ParcelTrackingStatus["DepartedFromOriginPort"] = "DepartedFromOriginPort";
    ParcelTrackingStatus["ArrivedAtDestinationPort"] = "ArrivedAtDestinationPort";
    ParcelTrackingStatus["CustomOnHold"] = "CustomOnHold";
    ParcelTrackingStatus["CustomCleared"] = "CustomCleared";
    ParcelTrackingStatus["CustomUnknown"] = "CustomUnknown";
    ParcelTrackingStatus["ArrivedAtSortCenter"] = "ArrivedAtSortCenter";
    ParcelTrackingStatus["DepartedFromSortCenter"] = "DepartedFromSortCenter";
    ParcelTrackingStatus["PickedUpByCarrier"] = "PickedUpByCarrier";
    ParcelTrackingStatus["InTransitByCarrier"] = "InTransitByCarrier";
    ParcelTrackingStatus["ReadyForDelivery"] = "ReadyForDelivery";
    ParcelTrackingStatus["Delivered"] = "Delivered";
    ParcelTrackingStatus["DeliveryFailed"] = "DeliveryFailed";
    ParcelTrackingStatus["FlexIdLinked"] = "FlexIdLinked";
    ParcelTrackingStatus["ReturnInitiated"] = "ReturnInitiated";
    ParcelTrackingStatus["ReturnInTransit"] = "ReturnInTransit";
    ParcelTrackingStatus["OutForReturn"] = "OutForReturn";
    ParcelTrackingStatus["ReturnCompleted"] = "ReturnCompleted";
})(ParcelTrackingStatus || (exports.ParcelTrackingStatus = ParcelTrackingStatus = {}));
var ParcelTrackingEventTypes;
(function (ParcelTrackingEventTypes) {
    ParcelTrackingEventTypes["Created"] = "Created";
    ParcelTrackingEventTypes["Repurchased"] = "Repurchased";
    ParcelTrackingEventTypes["Cancelled"] = "Cancelled";
    ParcelTrackingEventTypes["PickedUpFromOrigin"] = "PickedUpFromOrigin";
    ParcelTrackingEventTypes["ArrivedAtOriginPort"] = "ArrivedAtOriginPort";
    ParcelTrackingEventTypes["DepartedFromOriginPort"] = "DepartedFromOriginPort";
    ParcelTrackingEventTypes["ArrivedAtDestinationPort"] = "ArrivedAtDestinationPort";
    ParcelTrackingEventTypes["CustomOnHold"] = "CustomOnHold";
    ParcelTrackingEventTypes["CustomUnknown"] = "CustomUnknown";
    ParcelTrackingEventTypes["CustomCleared"] = "CustomCleared";
    ParcelTrackingEventTypes["ArrivedAtSortCenter"] = "ArrivedAtSortCenter";
    ParcelTrackingEventTypes["DepartedFromSortCenter"] = "DepartedFromSortCenter";
    ParcelTrackingEventTypes["PickedUpByCarrier"] = "PickedUpByCarrier";
    ParcelTrackingEventTypes["InTransitByCarrier"] = "InTransitByCarrier";
    ParcelTrackingEventTypes["ReadyForDelivery"] = "ReadyForDelivery";
    ParcelTrackingEventTypes["Delivered"] = "Delivered";
    ParcelTrackingEventTypes["DeliveryFailed"] = "DeliveryFailed";
    ParcelTrackingEventTypes["FlexIdLinked"] = "FlexIdLinked";
    ParcelTrackingEventTypes["ReturnInitiated"] = "ReturnInitiated";
    ParcelTrackingEventTypes["ReturnInTransit"] = "ReturnInTransit";
    ParcelTrackingEventTypes["OutForReturn"] = "OutForReturn";
    ParcelTrackingEventTypes["ReturnCompleted"] = "ReturnCompleted";
})(ParcelTrackingEventTypes || (exports.ParcelTrackingEventTypes = ParcelTrackingEventTypes = {}));
//# sourceMappingURL=ParcelTracking.js.map